type DateLike = string | number | Date | null | undefined;
const toDate = (v: DateLike): Date | null => {
  if (v == null) return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const metDeadline = (deadline: DateLike, doneAt: DateLike): boolean => {
  const dl = toDate(deadline);
  const done = toDate(doneAt);
  if (!dl || !done) return false; // treat missing as not met
  return done.getTime() <= dl.getTime();
};

export const randomPassword = (
  length = 12,
  charset = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^*_+-',
) => {
  const cryptoObj = globalThis.crypto;
  if (!cryptoObj?.getRandomValues) throw new Error('Secure crypto not available');

  const chars = Array.from(charset);
  const result: string[] = [];

  // Rejection sampling to avoid modulo bias
  const max = 256 - (256 % chars.length); // largest multiple of chars.length < 256
  const buf = new Uint8Array(length * 2); // a bit extra in case of rejections
  cryptoObj.getRandomValues(buf);
  let i = 0,
    j = 0;
  while (i < length) {
    if (j >= buf.length) {
      cryptoObj.getRandomValues(buf);
      j = 0;
    }
    const r = buf[j++];
    if (r >= max) continue; // reject and retry
    result.push(chars[r % chars.length]);
    i++;
  }
  return result.join('');
};
